import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ChakraProvider } from '@chakra-ui/react';
import { useState, useEffect } from 'react';

import DashboardLayout from './layouts/MainPanel.js';

const queryClient = new QueryClient();

const App = () => {
  return (
    <ChakraProvider>
      <HashRouter>
        <QueryClientProvider client={queryClient}>
          <Switch>
            <Route path="/" component={DashboardLayout} />
          </Switch>
        </QueryClientProvider>
      </HashRouter>
    </ChakraProvider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
